import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'underscore';

import { withUiBlock } from '@bingads-webui/uiblocker';
import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const withGetCount = (WrappedComponent) => {
  class HoC extends React.Component {
    static displayName = `withGetCount(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      channel: PropTypes.string.isRequired,
      campaignType: PropTypes.number,
      dataService: PropTypes.shape({
        getCount: PropTypes.func.isRequired,
      }).isRequired,
      /**
       * element to be covered by uiblocker when loading data.
       */
      el: PropTypes.string.isRequired,
      isGetCountByCampaignAdGroups: PropTypes.bool,
    };

    static defaultProps = {
      campaignType: null,
      isGetCountByCampaignAdGroups: false,
    }

    state = {
      data: null,
    };

    componentDidMount = () => {
      this.reload();
    };

    componentWillUnmount = () => {
      this.cancel();
    };

    reload = () => {
      this.cancel();

      const {
        channel,
        campaignType,
        dataService,
        isGetCountByCampaignAdGroups,
      } = this.props;

      const options = _.defaults({}, { channel, campaignType });
      this.loadToken = isGetCountByCampaignAdGroups ?
        createAsyncToken(dataService
          .getCountByCampaignAdGroups(this.props))
          .on({
            onSuccess: ({
              data,
            }) => {
              this.setState({ data });
            },
          })
        : createAsyncToken(dataService
          .getCount(options)
          .finally(withUiBlock($(this.props.el))))
          .on({
            onSuccess: ({
              data,
            }) => {
              this.setState({ data });
            },
          });
    };

    cancel = () => {
      if (this.loadToken) {
        this.loadToken.cancel();
      }
    };

    render = () => {
      if (this.state.data === null) return null;

      return (<WrappedComponent
        data={this.state.data}
        {...this.props}
      />);
    };
  }

  return hoistNonReactStatics(HoC, WrappedComponent);
};
